import React from "react";
import Select from "react-select";
import { connect } from "react-redux";

class CRT extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="py-1 col-md-6 col-xs-12">
        Código de Atividade Principal (CNAE)
        <Select />
      </div>
    );
  }
}

export default connect()(CRT);



// WEBPACK FOOTER //
// ./src/components/parts/person/personAdaptToCompany/cnae/index.jsx